// extracted by mini-css-extract-plugin
module.exports = {"trigger":"Tooltip_trigger__3IC21","tooltip":"Tooltip_tooltip__3k5G6","inner":"Tooltip_inner__kp5ks","arrow":"Tooltip_arrow__1CVhV"};